import clsx from "clsx";

export const PlatformStatusIcon = ({
  status,
}: {
  status?: "configured" | "not-configured";
}) => (
  <div className="inline-flex items-center">
    <i
      className={clsx("font-extrabold fa-regular", {
        "fa-link-simple-slash": status !== "configured",
        "text-gray": status !== "configured",
        "fa-check": status === "configured",
        "text-alien+0": status === "configured",
      })}
    />
  </div>
);
